import React from "react";
import PropTypes from "prop-types";
import "../../../styles/button.scss";
import { useFormikContext } from "formik";

import LoadingIcon from "../../../assets/icons/loading.gif";
import { ReactComponent as LoadingSvg } from "../../../assets/icons/loading.svg";
import { Tooltip } from "react-tooltip";

const Button = ({
  variant,
  label,
  leadingIcon,
  trailingIcon,
  width,
  disabled,
  className,
  textAlign,
  submitting,
  tooltipId,
  tooltipContent,
  style,
  size,
  ...props
}) => {
  const classNames = [className, "button", `button--${variant}`];
  const contentClassNames = ["button-contents__label"];
  const formikContext = useFormikContext();

  if (disabled) classNames.push("button--disabled");

  if (submitting || formikContext?.isSubmitting)
    classNames.push("button--submitting");

  if (!textAlign && !leadingIcon && !trailingIcon) {
    contentClassNames.push("button-contents__label--align-center");
  }

  if (textAlign === "center") {
    contentClassNames.push("button-contents__label--align-center");
  }

  if (textAlign === "left") {
    contentClassNames.push("button-contents__label--align-left");
  }

  if (textAlign === "right") {
    contentClassNames.push("button-contents__label--align-right");
  }

  return (
    <button
      type="button"
      className={classNames.join(" ")}
      style={{ width, ...style }}
      {...props}
      data-size={size ?? ""}
    >
      <div className="button-contents">
        {leadingIcon && (
          <div className="button-contents__icon button-contents__icon--leading">
            {leadingIcon}
          </div>
        )}
        <div className={contentClassNames.join(" ")}>{label}</div>
        {trailingIcon && (
          <div className="button-contents__icon button-contents__icon--trailing">
            {trailingIcon}
          </div>
        )}

        {submitting && (
          <div className="button-contents__icon button-contents__icon--submitting">
            <LoadingSvg />
          </div>
        )}
      </div>
    </button>
  );
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  leadingIcon: PropTypes.element,
  trailingIcon: PropTypes.element,
  variant: PropTypes.oneOf(["primary", "secondary", "tertiary"]),
  disabled: PropTypes.bool,
  textAlign: PropTypes.string,
};

Button.defaultProps = {
  variant: "primary",
  onClick: undefined,
  disabled: false,
};

export default Button;
